import {FC} from 'react';
import {AudioButton} from '../audioButton/audioButton';
import {FullscreenButton} from '../fullscreenButton';
import {MuteUnmuteButton} from '../muteUnmuteButton';
import {PlayPauseButton} from '../playPauseButton';
import {ProgressBar} from '../progressBar';
import {SubtitleButton} from '../subtitleButton';
import {TimeStamp} from '../timestamp';
import {VolumeBar} from '../volumeBar/volumeBar';
import * as Styles from './controlBar.styles';

export const ControlBar: FC = () => {
  return (
    <Styles.ControlsContainer>
      <ProgressBar />
      <Styles.ControlBar>
        <Styles.ControlGroup>
          <PlayPauseButton />
          <MuteUnmuteButton />
          <VolumeBar />
          <TimeStamp />
        </Styles.ControlGroup>
        <Styles.ControlGroup>
          <AudioButton />
          <SubtitleButton />
          <FullscreenButton />
        </Styles.ControlGroup>
      </Styles.ControlBar>
    </Styles.ControlsContainer>
  );
};
